import React, { useEffect, useState,forwardRef } from "react";
import DraggableImage from "../Banner/DraggableImage";
import { Stage, Layer } from "react-konva";
import DraggableText from "../Banner/DraggableTextBox";

export default forwardRef(({ selectedBanner,selectShape,selectedAssets,selectedId,changeAsset,text,changeEntireText },ref) => {
  const [parentWidthHeight, setParentWidthHeight] = useState();
  const [download, setDownload] = useState(false);
  const checkDeselect = (e) => {
    const clickedOnEmpty = e.target === e.target.getStage();
    if (clickedOnEmpty) {
      selectShape(null);
    }
  };

  return (
    <>
      <div
        className="profile-picture"
      >
        <div 
          style={{
            backgroundImage: `url(${selectedBanner})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition: "center",
            width:"400px",
            height: "400px",
            borderRadius:"25px"
          }}
          ref={ref}
          id = "profilebackground"
        >
                  <Stage
                      width={400}
                      height={400}
                      onMouseDown={checkDeselect}
                      onTouchStart={checkDeselect}
                  >
                      <Layer>
                        {Object.keys(selectedAssets).map((key) => {
                          return (
                            <DraggableImage
                              key={key}
                              shapeProps={selectedAssets[key]}
                              isSelected={selectedAssets[key].id === selectedId}
                              onSelect={() => {
                                selectShape(selectedAssets[key].id);
                              }}
                              onChange={(newAttrs) => {
                                changeAsset(key, {
                                  ...selectedAssets[key],
                                  ...newAttrs,
                                });
                              }}
                              link={selectedAssets[key].url}
                            />
                          );
                        })}

                        {Object.keys(text).map((key) => {
                          return text[key].text ? (
                            <DraggableText
                              key={key}
                              shapeProps={text[key]}
                              isSelected={text[key].id === selectedId}
                              onSelect={() => {
                                selectShape(text[key].id);
                              }}
                              onChange={(newAttrs) => {
                                changeEntireText(key, {
                                  ...text[key],
                                  ...newAttrs,
                                });
                              }}
                              text={text[key].text}
                            />
                          ) : (
                            <></>
                          );
                        })}
                      </Layer>
                    </Stage>
       
        </div>
       
      </div>
      
    </>
  );
})
